import React from 'react';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';

export const LABEL_INPUT_FONT_SIZE = { fontSize: 14 };

export const FICHAS_TECNICAS_LINK_LIST_BUTTONS = [
  {
    title: {
      text: 'Ayuda',
      color: '#5D9405',
    },
    icon: <ImportContactsIcon />,
    backgroundColor: '#D7F5B1',
    link: '/fichas-tecnicas/ayuda',
  },
];

export const changeDateFormat = (inputDate) => {
  var parts = inputDate.split("-");
  var formattedDate = parts[2] + "/" + parts[1] + "/" + parts[0];
  return formattedDate;
}

export const changeDateFormatFromSlashToDash = (inputDate) => {
  var parts = inputDate.split("-");
  var formattedDate = parts[2] + "-" + parts[1] + "-" + parts[0];
  return formattedDate;
}

export const reformatDateYYYYmmDD = (dateString) => {

  if (dateString === null) {
    return ''
  } else {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regex)) {
      let dateParts = dateString.split("-");
      let reformattedDate = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];

      return reformattedDate;
    } else {
      return dateString
    }
  }



}

export const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return '';

  const [year, month, day] = dateString.split('-');

  if (!year || !month || !day) return '';

  return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
};


export const formatRut = (rut) => {
  rut = rut.replace(/[^\dKk]/g, '').toUpperCase();
  let number = rut.slice(0, -1);
  let verifier = rut.slice(-1);
  number = number.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return number + '-' + verifier;
};

export const handleRutChange = (event, setRut) => {
  let inputRut = event.target.value;
  inputRut = inputRut.slice(0, 13);
  const formattedRut = formatRut(inputRut);
  setRut(formattedRut);
};

export const validateMail = correo => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (regex.test(correo)) {
    return true
  } else {
    return false
  }
}

export const validateWebUrl = web => {
  const regex = /^(https:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/[^\s]*)?$/;
  if (regex.test(web)) {
    return true
  } else {
    return false
  }
}

export const hasError = (field) => {
  if (field) {
    return true
  } else {
    return false
  }
}

export const validateRut = (rut) => {
  if (!rut || rut.length < 3) return false;

  const cleanRut = rut.replace(/[.-]/g, '');
  const rutNumber = cleanRut.slice(0, -1);
  const rutVerifier = cleanRut.slice(-1).toUpperCase();
  let sum = 0;
  let mul = 2;

  for (let i = rutNumber.length - 1; i >= 0; i--) {
    sum += parseInt(rutNumber[i], 10) * mul;
    mul = (mul + 1) % 8 || 2;
  }

  const expectedVerifier = (11 - (sum % 11)).toString();
  const verifier = expectedVerifier === '11' ? '0' : expectedVerifier === '10' ? 'K' : expectedVerifier;

  return verifier === rutVerifier;
};

export const validateField = (str, setVal) => {
  if (str) {
    setVal('')
    return true
  } else {
    setVal('Campo requerido')
    return false
  }
}

//export const ordenarArregloAlfabeticamente = (arr) => arr.sort((a, b) => a.nombre.localeCompare(b.nombre));
export const ordenarArregloAlfabeticamente = (arr) => {
  return arr.sort((a, b) => {
    const aNombre = a.nombre.toLowerCase();
    const bNombre = b.nombre.toLowerCase();

    const aContainsOtr = aNombre.includes("otr");
    const bContainsOtr = bNombre.includes("otr");

    if (aContainsOtr === bContainsOtr) {
      return aNombre.localeCompare(bNombre);
    }
    return aContainsOtr ? 1 : -1;
  });
};

//export const ordenarArregloAlfabeticamenteEquipamiento = (arr) => arr.sort((a, b) => a.equipamiento.nombre.localeCompare(b.equipamiento.nombre));
export const ordenarArregloAlfabeticamenteEquipamiento = (arr) => {
  return arr.sort((a, b) => {
    const aNombre = a.equipamiento.nombre.toLowerCase();
    const bNombre = b.equipamiento.nombre.toLowerCase();

    const aContainsOtr = aNombre.includes("otr");
    const bContainsOtr = bNombre.includes("otr");


    if (aContainsOtr === bContainsOtr) {
      return aNombre.localeCompare(bNombre);
    }

    return aContainsOtr ? 1 : -1;
  });
};

export const levenshteinDistance = (a, b) => {
  const matrix = [];

  // Increment along the first column of each row
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  // Increment each column in the first row
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  // Fill in the rest of the matrix
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b[i - 1] === a[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1, // substitution
          matrix[i][j - 1] + 1,     // insertion
          matrix[i - 1][j] + 1      // deletion
        );
      }
    }
  }

  return matrix[b.length][a.length];
}

export const findMostSimilarString = (targetString, options) => {
  let closestMatch = options[0];
  let smallestDistance = levenshteinDistance(targetString, options[0]);

  for (let i = 1; i < options.length; i++) {
    const distance = levenshteinDistance(targetString, options[i]);
    if (distance < smallestDistance) {
      closestMatch = options[i];
      smallestDistance = distance;
    }
  }

  return closestMatch;
}

export const TEXTO_FICHAS_TECNICAS =
  'El proyecto "Portal de Entidades Externas" se propone como un recurso integral destinado a facilitar las interacciones entre la Superintendencia de Salud y diversas entidades externas, proporcionando un acceso seguro y eficiente a través de un portal en linea- Este portal, también denominado extranet, está diseñado para servir como una plataforma centralizada que permitirá a las entidades externas acceder a una amplia gama de servicios y recursos proporcionados por la Superintendencia';

export const antiguedadList = [

  { id: 1, antiguedad: "1 Año" },
  { id: 2, antiguedad: "2 Años" },
  { id: 3, antiguedad: "3 Años" },
  { id: 4, antiguedad: "4 Años" },
  { id: 5, antiguedad: "5 Años" },
  { id: 6, antiguedad: "6 Años" },
  { id: 7, antiguedad: "7 Años" },
  { id: 8, antiguedad: "8 Años" },
  { id: 9, antiguedad: "9 Años" },
  { id: 10, antiguedad: "10 Años" },
  { id: 11, antiguedad: "11 Años" },
  { id: 12, antiguedad: "12 Años" },
  { id: 13, antiguedad: "13 Años" },
  { id: 14, antiguedad: "14 Años" },
  { id: 15, antiguedad: "15 Años" },
  { id: 16, antiguedad: "16 Años" },
  { id: 17, antiguedad: "17 Años" },
  { id: 18, antiguedad: "18 Años" },
  { id: 19, antiguedad: "19 Años" },
  { id: 20, antiguedad: "20 Años" },
  { id: 21, antiguedad: "21 Años" },
  { id: 22, antiguedad: "22 Años" },
  { id: 23, antiguedad: "23 Años" },
  { id: 24, antiguedad: "24 Años" },
  { id: 25, antiguedad: "25 Años" },
  { id: 26, antiguedad: "26 Años" },
  { id: 27, antiguedad: "27 Años" },
  { id: 28, antiguedad: "28 Años" },
  { id: 29, antiguedad: "29 Años" },
  { id: 30, antiguedad: "30 Años" },


]

export const unidadesList = [
  "Seleccione",
  "unidad 1",
  "unidad 2",
  "unidad 3",
  "unidad 4",
  "unidad 5",
]

export const NOM_LOGICO_EQUIPAMIENTO_GENERAL = [
  'equipamiento-general-hospitalario',
  'equipamiento-general-ambulatorio',
]

export const removeNulls = (obj) => {
  if (Array.isArray(obj)) {
    return obj
      .filter(item => ((item !== null) && (item !== undefined)))
      .map(item => removeNulls(item));
  } else if (typeof obj === 'object' && obj !== null && obj !== undefined) {
    Object.keys(obj).forEach(key => {
      obj[key] = removeNulls(obj[key]);
    });
  }
  return obj;
}

export const tiposAux = [
  { value: 0, label: 'Seleccione' },
  { value: 1, label: 'Propio' },
  { value: 2, label: 'Compra de servicios' },
]

/*   export const removeNulls = (obj) => {
        if (Array.isArray(obj)) {
            return obj
                .filter(item => ((item !== null) && (item !== undefined)))
                .map(item => removeNulls(item));
        } else if (typeof obj === 'object' && obj !== null && obj !== undefined) {
            Object.keys(obj).forEach(key => {
                obj[key] = removeNulls(obj[key]);
            });
        }
        return obj;
    } */


export const removeDuplicates = (arr) => {

  let auxIds = [];

  arr.forEach((item) => {
    if (item.is_servicio_padre) {
      auxIds = auxIds.concat(item.servicios_internos.map((hijo) => hijo.id));
    }
  });

  return arr.filter((item) => !auxIds.includes(item.id));
};

export const ordenarEquipamientoGeneralPrimero = (data) => {

  const index = data.findIndex(item => NOM_LOGICO_EQUIPAMIENTO_GENERAL.includes(item.nombre_logico))
  if (index !== -1 && index !== 0) {
    const [euipamientoGeneral] = data.splice(index, 1);
    data.unshift(euipamientoGeneral);
  }
  return data
}